import
{
    PaginatedResult,
    PaginationRequest,
    PriceList
} from '@ews/react-data';

import
{
    LoadingContextType,
    useLoadingIndicator
} from "../Loading";

import
{
    useTopicData,
    useWebsocket
} from './ReactDataProvider';

import
{
    ReactTopics
} from '@ews/websocket-service';

import
{
    useCallback,
    useEffect,
    useState
} from 'react';

export const useActivePriceList = (priceListId?: string) =>
{
    const fetchPriceLists = useFetchPriceList();

    const [priceList, setPriceList] = useState<PriceList>();

    useEffect(() =>
    {
        const handleRequest = async () =>
        {
            const response = await fetchPriceLists(priceListId ? {
                "pageSize": 1,
                "id": priceListId
            } : {
                "pageSize": 1,
                "default": 1
            });
            setPriceList(response.results[0]);
        };

        const timeout = setTimeout(handleRequest, 100);
        return () => clearTimeout(timeout);

    }, [fetchPriceLists, priceListId]);

    return priceList;
};

export const usePriceList = (priceListId: string) =>
{
    return useTopicData<PriceList>(`${ReactTopics.priceList.withParams({ priceListId })}`, {} as PriceList);
};

export const useModifyPriceList = () => 
{
    const loadingToggle = useLoadingIndicator();
    const provider = useWebsocket();

    return useCallback(async (priceListId: string, data: PriceList) =>
        provider.modify(data, `${ReactTopics.priceList.withParams({ priceListId })}`, loadingToggle),
        [loadingToggle, provider]);
};

export const useRemovePriceList = () => 
{
    const loadingToggle = useLoadingIndicator();
    const provider = useWebsocket();

    return useCallback(async (priceListId: string) =>
        provider.delete(`${ReactTopics.priceList.withParams({ priceListId })}`, loadingToggle),
        [loadingToggle, provider]);
};

export const useCreatePriceList = () =>
{
    const loadingToggle = useLoadingIndicator();
    const provider = useWebsocket();

    return useCallback(async (name: string) =>
    {
        const priceList = { name } as PriceList;
        return await provider.create(priceList, `${ReactTopics.priceList.withParams({ priceListId: null })}`, loadingToggle);
    }, [loadingToggle, provider]);
};

export const useFetchPriceList = () =>
{
    const loadingToggle = useLoadingIndicator();
    return useTypeAheadPriceList(loadingToggle);
};

export const useTypeAheadPriceList = (loadingToggle?: LoadingContextType) =>
{
    const provider = useWebsocket();

    return useCallback(async (filterCriteria: PaginationRequest,) =>
    {
        return provider.fetch<PaginatedResult<PriceList>>(filterCriteria, `${ReactTopics.priceList.withParams({ priceListId: null })}`, loadingToggle);
    }, [loadingToggle, provider]);
};
